import styled from '@emotion/styled';
import { Close } from '@emotion-icons/evaicons-solid';

interface ICloseButtonProps {
  onClose(): void;
  className?: string;
}

const CloseWrapper = styled.div`
  height: 36px;
  width: 36px;
  min-height: 36px;
  min-width: 36px;
  max-height: 36px;
  max-width: 36px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: var(--neut7);
  }
`;

const CloseButton = ({ onClose, className }: ICloseButtonProps) => {
  return (
    <CloseWrapper onClick={onClose} className={`${className ?? ''} center`}>
      <Close size={32} />
    </CloseWrapper>
  );
};

export default CloseButton;
